import React from 'react';
import OptionsContext from '../contexts/options';

export default (WrappedComponent) => (props) => (
  <OptionsContext.Consumer>
    {({ namespacedStateEntry }) => (
      <WrappedComponent
        namespacedStateEntry={namespacedStateEntry}
        {...props}
      />
    )}
  </OptionsContext.Consumer>
);
